export const invitationType = [
  {
    id: 1,
    destination: 'Team',
    name: 'Invite Player to Team',
    name_full: 'Invite Player to join a Team',
  },
  {
    id: 2,
    destination: 'Team',
    name: 'Invite User to Team',
    name_full: 'Invite User to join a Team',
  },
  {
    id: 3,
    destination: 'Competition',
    name: 'Invite Team to Competition',
    name_full: 'Invite Team to join a Competition',
  },
  {
    id: 4,
    destination: 'Competition',
    name: 'Invite User to Competition',
    name_full: 'Invite User to join a Competition',
  },
  {
    id: 6,
    destination: 'Organization',
    name: 'Invite User to Organization',
    name_full: 'Invite User to join an Organization',
  },
  {
    id: 7,
    destination: 'Organization',
    name: 'Invite Official to Organization',
    name_full: 'Invite Official to join an Organization',
  },
  {
    id: 8,
    destination: 'Competition',
    name: 'Invite Official to Competition',
    name_full: 'Invite Official to join a Competition',
  },
  {
    id: 9,
    destination: 'Team',
    name: 'Invite Team Official to Team',
    name_full: 'Invite Team Official to join a Team',
  },
  {
    id: 10,
    destination: 'Team',
    name: 'Invite Team Rep to Team',
    name_full: 'Invite Team Rep to join a Team',
  },
  {
    id: 11,
    destination: 'Game',
    name: 'Invite User to Game',
    name_full: 'Invite User to join a Game',
  },
  {
    id: 12,
    destination: 'Game',
    name: 'Official to Game',
    name_full: 'Invite Official to join a Game',
  },
  {
    // Affiliate league admin. Same org-admin grant as type 6 — kept separate so the
    // onboarding email can use its own template — so it routes to the Organization,
    // landing the new admin on their league after they accept.
    id: 14,
    destination: 'Organization',
    name: 'Affiliate Admin to Organization',
    name_full: 'Invite an Affiliate League admin to their Organization',
  },
  {
    // Jeff, Oct 1 — a Team Budget slot held for the invitee. It is taken by
    // REGISTERING for the team on the web, never by accepting the invite; the
    // destination is the team the slot is on.
    id: 15,
    destination: 'Team',
    name: 'Invite User to Team Registration',
    name_full: 'Invite User to register for a Team',
  },
]
